import { useTranslation } from 'react-i18next'
import { RuuviTag } from '../types'
import StatusIndicator from './StatusIndicator'
import { AssetStatus } from '../types/Asset'
import { Tooltip } from '@mui/material'
import { Circle } from '@mui/icons-material'

/**
 * The props of the ruuvi tag status indicator.
 */
interface RuuviTagStatusIndicatorProps {
  /**
   * The ruuvi tag.
   */
  ruuviTag: RuuviTag

  /**
   * The font size.
   */
  fontSize?: 'small' | 'medium' | 'large' | 'inherit'
}

/**
 * An indicator for the ruuvi tag status.
 */
export default function RuuviTagStatusIndicator({
  ruuviTag,
  fontSize = 'inherit'
}: RuuviTagStatusIndicatorProps): React.ReactElement {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  return (
    <>
      {ruuviTag?.asset?.status === AssetStatus.INACTIVE ? (
        <Tooltip title={t('detached') as string}>
          <Circle color="disabled" fontSize={fontSize} />
        </Tooltip>
      ) : (
        <StatusIndicator status={ruuviTag.status} fontSize={fontSize} />
      )}
    </>
  )
}
